import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import Modali, { useModali } from 'modali';
import { useSelector } from 'react-redux';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import cx from 'classnames';

import CardsList from './components/CardsList/CardsList';

const PaymentsWrapper = React.lazy(() => import('../../../containers/PaymentsWrapper/PaymentsWrapper'));

const PaymentElement = ({
  input, hidden, meta: { error, touched },
}) => {
  const paymentOptions = useSelector(
    (state) => state.paymentDetails.paymentOptions,
  );
  const [showAddCard, setShowAddCard] = useModali({
    title: 'Add new credit or debit card',
    animated: true,
    centered: true,
    large: true,
  });

  if (hidden) {
    return null;
  }
  return (
    <div className="my-3">
      {error && (
        <div className="row">
          <div className="col">
            <div
              className={cx('alert', 'alert-primary', {
                'alert-danger': touched,
              })}
            >
              Please provide your card information below. This card will be
              charged once the&nbsp; final fees and costs have been determined.
            </div>
          </div>
        </div>
      )}
      <CardsList
        onChange={input.onChange}
        value={input.value}
        paymentOptions={paymentOptions}
        setShowAddCard={setShowAddCard}
      />
      <Modali.Modal {...showAddCard}>
        <Suspense fallback={<div>Loading...</div>}>
          <PaymentsWrapper
            onSuccess={(res) => {
              if (res.setupIntent) {
                input.onChange(res.setupIntent.payment_method);
              }
            }}
            setShowAddCard={setShowAddCard}
          />
        </Suspense>
      </Modali.Modal>
      {input.value
      && !paymentOptions.some(
        ({ paymentMethodId }) => input.value === paymentMethodId,
      ) && (
        <ul className="list-group mt-3">
          <li className="list-group-item d-flex justify-content-between cards-list__row cards-list__row-active">
            Single-use card selected
          </li>
        </ul>
      )}
    </div>
  );
};

PaymentElement.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  hidden: PropTypes.bool,
};
PaymentElement.defaultProps = {
  hidden: false,
};

export default PaymentElement;
